import React, { useCallback, useEffect, useState } from 'react';
import { getTranslation } from './carouselTranslations';

export const usePrevNextButtons = (emblaApi, onButtonClick) => {
	const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
	const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

	const onPrevButtonClick = useCallback(() => {
		if (!emblaApi) return;
		emblaApi.scrollPrev();
		if (onButtonClick) onButtonClick(emblaApi);
	}, [emblaApi, onButtonClick]);

	const onNextButtonClick = useCallback(() => {
		if (!emblaApi) return;
		emblaApi.scrollNext();
		if (onButtonClick) onButtonClick(emblaApi);
	}, [emblaApi, onButtonClick]);

	const onSelect = useCallback((emblaApi) => {
		setPrevBtnDisabled(!emblaApi.canScrollPrev());
		setNextBtnDisabled(!emblaApi.canScrollNext());
	}, []);

	useEffect(() => {
		if (!emblaApi) return;

		onSelect(emblaApi);
		emblaApi.on('reInit', onSelect).on('select', onSelect);
	}, [emblaApi, onSelect]);

	return {
		prevBtnDisabled,
		nextBtnDisabled,
		onPrevButtonClick,
		onNextButtonClick,
	};
};

export function PrevButton(props) {
	const { children, language = 'en', ...restProps } = props;

	return (
		<button
			type="button"
			className="w-10 h-10 flex items-center justify-center rounded-full bg-white/80 hover:bg-white shadow-md backdrop-blur-sm border border-gray-200 hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none"
			aria-label={getTranslation(language, 'previousSlide')}
			{...restProps}
		>
			<svg
				className="w-5 h-5 text-gray-700"
				fill="none"
				stroke="currentColor"
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="2"
					d="M15 19l-7-7 7-7"
				/>
				{children}
			</svg>
		</button>
	);
}

export function NextButton(props) {
	const {
		children,
		language = 'en',
		...restProps
	} = props;

	return (
		<button
			type="button"
			className="w-10 h-10 flex items-center justify-center rounded-full bg-white/80 hover:bg-white shadow-md backdrop-blur-sm border border-gray-200 hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none"
			aria-label={getTranslation(language, 'nextSlide')}
			{...restProps}
		>
			<svg
				className="w-5 h-5 text-gray-700"
				fill="none"
				stroke="currentColor"
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="2"
					d="M9 5l7 7-7 7"
				/>
				{children}
			</svg>
		</button>
	);
}
